import { render, staticRenderFns } from "./CreateIncidentTypeModal.vue?vue&type=template&id=1a95efac&scoped=true"
import script from "./CreateIncidentTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateIncidentTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateIncidentTypeModal.vue?vue&type=style&index=0&id=1a95efac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95efac",
  null
  
)

export default component.exports